module.exports = __webpack_public_path__ + "img/9788959522958.21df71df.jpg";